import { StorageService } from './storage-service';

export const SessionStorageService = {
  setItem: <T>(storageItemName: string, value: T, expirationInSeconds?: number): void => {
    StorageService.setItem(window.sessionStorage, storageItemName, value, expirationInSeconds);
  },
  getItem: <T>(storageItemName: string): T | null => {
    return StorageService.getItem(window.sessionStorage, storageItemName);
  }
};
